import { PlanePoint } from '../mathematic-plane';

export class CursorPosition extends PlanePoint {
    public lineAngle: number;
    public lineLength: number;
}
